module.exports = __webpack_public_path__ + "img/commercial_invoice.24d7646a.png";